import { createAction } from 'redux-actions';

import query from './ducks/query';
import { RETRY_FETCH } from './types';

export const {
  removeFilters,
  updateFilters,
  updateLimit,
  updatePage,
  updateSort,
} = query.actions;

export const retryFetch = createAction(RETRY_FETCH);
